<template>
  <nav class="nav">
    <div class="container">
      <div class="subscribeMod">
        <span class="noMob">Subscribe</span>
        <subscribe-module class="noMob" />
      </div>
      <!-- This "nav-menu" is hidden on mobile -->
      <!-- Add the modifier "is-active" to display it on mobile -->
      <div class="nav-right nav-menu" :class="searching ? 'is-searching' : ''">
        <div class="nav-item nav-button" v-for="button in topBarButtons" :key="button.id">
          <a :href="button.link.url" class="button" :class="`is-${button.style}`"
            v-if="button.link.url.startsWith('#')">
            <span>{{ button.text }}</span>
          </a>
          <router-link :to="getPath(button.link.url)" class="button" :class="`is-${button.style}`"
            v-else-if="button.link.target !== '_blank'">
            <span>{{ button.text }}</span>
          </router-link>
          <a :href="button.link.url" class="button" :class="`is-${button.style}`" target="_blank"
            rel="noopener noreferrer" v-else>
            <span>{{ button.text }}</span>
          </a>
        </div>
        <div class="nav-item search">
          <search-module></search-module>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import NewsletterModule from './NewsletterModule'
import SearchModule from './SearchModule'
import SubscribeModule from './SubscribeModule'
import { mapGetters } from 'vuex'

export default {
  name: 'top-nav',
  data() {
    return {
      searching: false
    }
  },
  components: {
    NewsletterModule,
    SearchModule,
    SubscribeModule
  },
  computed: {
    ...mapGetters([
      'topBarButtons'
    ])
  },
  methods: {
    getPath(url) {
      if (!url) return '/'
      // If it's already a relative path, return it
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        return url
      }
      // Extract pathname from full URL
      try {
        const urlObj = new URL(url)
        return urlObj.pathname + urlObj.search + urlObj.hash
      } catch (e) {
        // Fallback if URL parsing fails
        return url
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  @import ../../assets/styles/colors
  @import ../../assets/styles/mixins

  .subscribeMod
    display: flex
    align-items: center
    > span
      font-size: 12px
      color: #7a7a7a
      text-transform: uppercase
      letter-spacing: 0.6px

  .nav
    display: none
    .container
      justify-content: space-between
    +tablet
      display: flex
      padding: 0 30px
    +desktop
      padding: 0

  .nav-right
    flex: 1
    overflow: visible
    +tablet-only
      .nav-item:first-child
        padding-left: 0
    +tablet
      justify-content: flex-start
      flex: none
    +smDesktop
      justify-content: space-between
    .nav-item
      padding: 0.5rem
      &.search
        padding-right: 0
  .button
    color: $textColor
    font-weight: bold
    height: 36px
    white-space: normal
    font-size: 14px
    line-height: 1
    padding-left: 1em
    padding-right: 1em
    +tablet
      display: none
    +smDesktop
      margin-left: 0
      display: flex
      width: 120px
      font-size: 13px
    +desktop
      padding-left: 1.25em
      padding-right: 1.25em
      font-size: 14px
      width: 136px
    &:hover, &:focus
      color: $textColor
    &.is-warning:hover
      background-color: darken($yellow, 11%)
    &.is-tertiary
      background-color: $green
      &:hover
        background-color: darken($green, 10%)

</style>



// WEBPACK FOOTER //
// TopNav.vue?6b2bb74d